import MedicationAnswer from "../abstract/MedicationAnswer"
import BoolQuestionAnswerStrategy from "../abstract/BoolQuestionAnswerStrategy"
import MedicationQuestion from "../abstract/MedicationQuestion"
import QuestionCreator from "../abstract/QuestionCreator"

const PatientAgeIsAtLeast =
    (
        age: number,
        answer: MedicationAnswer,
        optional: {
            strategy: BoolQuestionAnswerStrategy
            followedBy?: MedicationQuestion
            alternativeAnswer?: MedicationAnswer
        } = { strategy: BoolQuestionAnswerStrategy.ON_YES }
    ): QuestionCreator =>
    (input) =>
        new MedicationQuestion(
            `Ist die Patient:in mindestens ${String(age)} Jahre alt?`,
            input
        ).answerAutomatically((input) => {
            if (input.patientAgeIsAtLeast(age)) {
                return optional.strategy === BoolQuestionAnswerStrategy.ON_YES
                    ? answer
                    : optional.alternativeAnswer
                      ? optional.alternativeAnswer
                      : new MedicationAnswer("Ja")
            }
            return optional.strategy === BoolQuestionAnswerStrategy.ON_NO
                ? answer
                : optional.alternativeAnswer
                  ? optional.alternativeAnswer
                  : new MedicationAnswer("Nein")
        })

export default PatientAgeIsAtLeast
